import KeenSlider from 'keen-slider';

const wrapEls = document.querySelectorAll('.estate-objects__slider');

wrapEls.forEach(wrapEl => {
  const sliderEl = wrapEl.querySelector('.estate-objects__slider-wrap');
  const prevEl = wrapEl.querySelector('.estate-objects__button.swiper-button-prev');
  const nextEl = wrapEl.querySelector('.estate-objects__button.swiper-button-next');
  const slideEls = wrapEl.querySelectorAll('.estate-objects__slide');

  const slider = new KeenSlider(sliderEl, {
    selector: slideEls,
    slides: {
      perView: 1,
      spacing: 0
    },
    breakpoints: {
      '(min-width: 600px)': {
        slides: {
          perView: 2,
          spacing: 20
        }
      },
      '(min-width: 992px)': {
        slides: {
          perView: 1
        }
      }
    },
    
    created() {
      window.lazyObserver.observe();
    }
  });

  prevEl.onclick = () => slider.prev();
  nextEl.onclick = () => slider.next();
});